import type { TMessages } from '@/types/TMessages'

export const messages = {
  asideNewsHeader: 'Новости',
  readMoreHeader: 'Читайте также',
  allNewsCaption: 'Все новости',
  todaylabel: 'Сегодня',
  yesterdayLabel: 'Вчера',
} satisfies TMessages
